export default "__VITE_ASSET__35e92de9__"